import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IDiagnosisNote;

const noteSlice = createSlice({
    name: "note",
    initialState,
    reducers: {
        setNote: (state, action: PayloadAction<IDiagnosisNote | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setNote } = noteSlice.actions;
export default noteSlice.reducer;

export const getNote = (state: RootState) => state.note;
